import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import type { AppState } from '~/store/app.store';
import { userIdSelector } from '~/store/userData/userData.selectors';

export const selectAllV4Maps = (state: AppState) => state.mapMigration.v4MapInfos;

export const usersMapsForMigrationSelector = createStateSelector([selectAllV4Maps, userIdSelector],
  (v4MapInfos, userId) => v4MapInfos.filter(v4MapInfo => v4MapInfo.mapOwnerId === userId),);
